import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		tituloOuAutor: {
			value: null,
			default: null,
			label: 'Autor ou Titulo',
		},
	},
	modalPenalidade: {
		idPenalidade: {
			value: null,
		},
	},
	documentosSelecionados: [],
	isSelecionouTodosItensDaListaDeDocumentosPedido: null,
	paginacao: paginacaoListagem('id', 5, 'ASC'),
}
